interface IParams {
  key: string;
  group?: string;
  value: any;
  context: {
    cache: any;
  };
}

/**
 * Set a value in cache
 *
 * @param {string} key key where to store the value
 * @param {string} group if present, group where to store the value
 * @param {any} value value to store
 */
function setCache({ key, group, value, context }: IParams) {
  const { cache } = context;

  if (!group) {
    cache[key] = value;
  } else {
    if (!cache[group]) {
      cache[group] = {};
    }
    cache[group][key] = value;
  }
}

export default setCache;
